import 'css-chunksrc/client/pages/capacityPage/table/row/cell/styles.scss';export default {
  "cell": "_cell_2e03z_1",
  "failed": "_failed_2e03z_13",
  "value": "_value_2e03z_17"
};